import type {ChatMessage} from '../types';

import {buildGroupedActivityMessage} from './buildActivityGroupMessage';

export const GROUP_ACTIVITIES_TIME_WINDOW = 5 * 60000;

export const isSameActivityType = (
    previousMessage: ChatMessage,
    lastActivityMessages: ChatMessage,
) => previousMessage?.activityType === lastActivityMessages.activityType;

export const isActivityInTimeRange = (
    previousMessage: ChatMessage,
    lastActivityMessages: ChatMessage,
) => {
    if (previousMessage?.at && lastActivityMessages.at) {
        const lastMessageTime = lastActivityMessages.at;
        const timeRange = new Date(
            previousMessage.at.getTime() + GROUP_ACTIVITIES_TIME_WINDOW,
        );

        if (timeRange >= lastMessageTime) {
            return true;
        }
    }

    return false;
};

export const shouldAppendActivityMessage = (
    lastMessage: ChatMessage,
    newMessage: ChatMessage,
) =>
    lastMessage?.type === 'activity' &&
    isSameActivityType(lastMessage, newMessage) &&
    isActivityInTimeRange(lastMessage, newMessage);

export const getGroupActivityMessages = (
    messages: ChatMessage[],
    newMessage: ChatMessage,
) => {
    const lastMessage = messages.at(-1);

    if (lastMessage && shouldAppendActivityMessage(lastMessage, newMessage)) {
        messages.splice(
            messages.length - 1,
            1,
            buildGroupedActivityMessage(lastMessage, newMessage),
        );
        return Array.from(messages);
    }

    return [...messages, newMessage];
};
